module.exports = __webpack_public_path__ + "img/home-background.cb6b8844.svg";